<template>

    <section class="best-app-area pt-100 fix" :style="bgImg" id="donate">
         <div class="row">
                <div class="col-12">
                    <div class="section-title text-center">
                        <div class="title-icon"></div>
                        <h2 class="title">HOW CAN YOU HELP THE RHINOS</h2>
                        <p class="paragraph"><b>Through education, awareness and support we hope to make a difference in the fight against rhino poaching</b></p>
                    </div>
                </div>
            </div>
        <div class="container" style="margin-bottom:50px">
            <div class="row">
                <div class="col-xl-6 col-lg-6">
                    <div class="bestapp-content-inner text-center">
                        <div class="section-title text-center">
                          
                            <h2 style="margin-top: 20px" class="title">MONTHLY MEMBERSHIP</h2>
                        <p class="paragraph" style="margin-top:-20px"><b>A more indepth view of the rhino sanctuary</b></p>
                              
                                    <img src="../assets/img/xtra-view.jpg" class="screenshot-overlay">
                                
                        </div>
                        <div style="margin-top:-20px">
                            <p class="paragraph">Receive exclusive subscriber content about the rhinos at the Care for Wild sanctuary.</p>
                            <button @click="gotoPatreon()" class="read-more active" style="margin-top:20px"><i class="fa fa-medkit"></i> Subscribe</button>
                        </div>
                    </div>
                </div>
                    <div class="col-xl-6 col-lg-6">
                    <div class="bestapp-content-inner text-center">
                        <div class="section-title text-center">
                       
                            <h2 style="margin-top: 20px" class="title">ONCE OFF DONATION</h2>
                            <p class="paragraph" style="margin-top:-20px"><b>Your contribution can make a difference</b></p>
                         <img src="../assets/img/donate.jpg" class="screenshot-overlay">
                        </div>
                        <div style="margin-top:-20px">
                            <p class="paragraph">Donate to the care of the orphaned rhinos seen on the live cams through Given Gain and help make a real difference.</p>
                                    <button @click="gotoGive()" class="read-more active" style="margin-top:20px"><i class="fa fa-medkit"></i> Donate</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Bestapp',
    methods: {
    gotoPatreon() {
      window.open("https://www.patreon.com/careforwild");
    },
       gotoGive() {
      window.open("https://www.givengain.com/cc/care-for-wild/");
    },
  },
    props: ["bestappTwo"],
    data (){
        return {
            bgImg: {
                backgroundImage: `url(${require('../assets/img/bestapp-bg.jpg')})`
            }
        }
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/best-app.scss';
</style>
